import React, { useState } from 'react';
import { Table, Card, Button, Row, Col, Form } from 'react-bootstrap';
import { format } from 'date-fns';
import ReactPaginate from 'react-paginate';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const ServicesTable = ({ services }) => {
  const [expandedRows, setExpandedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const formatDate = (date) => {
    if (!date || isNaN(new Date(date).getTime())) return 'Invalid Date';
    return format(new Date(date), 'dd/MM/yyyy');
  };

  const toggleRowExpansion = (date) => {
    setExpandedRows((prev) =>
      prev.includes(date) ? prev.filter((row) => row !== date) : [...prev, date]
    );
  };

  const handlePageClick = ({ selected }) => setCurrentPage(selected);

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(0); // Reset to the first page when the number of rows per page changes
  };

  const paginatedServices = services.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );

  return (
    <Card className="mt-5 shadow-sm">
      <Card.Body>
        <Row className="mb-3">
          <Col>
            <Card.Title className="text-center mb-4">Services Summary</Card.Title>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            <Form.Select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="w-auto"
            >
              <option value={5}>Show 5</option>
              <option value={10}>Show 10</option>
              <option value={20}>Show 20</option>
            </Form.Select>
          </Col>
        </Row>
        <Table striped bordered hover className="table-responsive-sm">
          <thead className="table-dark">
            <tr>
              <th>Date of Service</th>
              <th>Total Amount</th>
              <th className="text-center">Details</th>
            </tr>
          </thead>
          <tbody>
            {paginatedServices.map((entry) => {
              const { dateOfService, groupedServices } = entry;
              const totalAmount = groupedServices.reduce(
                (sum, service) => sum + (service.sumOfAmount || 0),
                0
              );

              return (
                <React.Fragment key={dateOfService}>
                  <tr
                    onClick={() => toggleRowExpansion(dateOfService)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{formatDate(dateOfService)}</td>
                    <td>₹{totalAmount.toFixed(2)}</td>
                    <td className="text-center">
                      {expandedRows.includes(dateOfService) ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </td>
                  </tr>
                  {expandedRows.includes(dateOfService) && (
                    <tr>
                      <td colSpan={3}>
                        <Table bordered>
                          <thead>
                            <tr>
                              <th>Service Code</th>
                              <th>Service Name</th>
                              <th>Amount (₹)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {groupedServices.map((service, idx) => (
                              <tr key={idx}>
                                <td>{service.service}</td>
                                <td>{service.serviceName || 'N/A'}</td>
                                <td>₹{service.sumOfAmount.toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </Table>
        <ReactPaginate
          previousLabel="← Previous"
          nextLabel="Next →"
          pageCount={Math.ceil(services.length / rowsPerPage)}
          onPageChange={handlePageClick}
          containerClassName="pagination justify-content-center mt-3"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          activeClassName="active"
        />
      </Card.Body>
    </Card>
  );
};

export default ServicesTable;
